<template>

    <cms-view v-spinner="loading" :hide="loading">
        <cms-heading :title="pageTitle"></cms-heading>

        <cms-form-panel submit-button="Opslaan" :cancel-button="true" :submitting="submitting" @submit="submit">

            <cms-form-input title="Titel" name="title" v-model.trim="pendingLoggerType.title"
                            v-validate="'required'" data-vv-as="Titel" :error="error('title')"></cms-form-input>

            <cms-form-input type="number" step="any" min="0" title="Loggerkosten" hint="Per maand" name="loggerPrice" v-model.trim="pendingLoggerType.loggerPrice"
                            v-validate="'min_value:0'" data-vv-as="Loggerkosten" :error="error('loggerPrice')"></cms-form-input>

            <cms-form-input type="number" step="any" min="0" title="Storingskosten" hint="Per maand" name="failurePrice" v-model.trim="pendingLoggerType.failurePrice"
                            v-validate="'min_value:0'" data-vv-as="Storingskosten" :error="error('failurePrice')"></cms-form-input>

            <cms-form-input type="number" step="any" min="0" title="Portalkosten" hint="Per maand" name="usagePrice" v-model.trim="pendingLoggerType.usagePrice"
                            v-validate="'min_value:0'" data-vv-as="Portalkosten" :error="error('usagePrice')"></cms-form-input>

            <cms-form-input type="number" step="any" min="0" title="Backoffice kosten" hint="Per maand" name="backofficePrice" v-model.trim="pendingLoggerType.backofficePrice"
                            v-validate="'min_value:0'" data-vv-as="Backoffice kosten" :error="error('backofficePrice')"></cms-form-input>

            <cms-form-input type="number" step="any" min="0" title="Handmeetrondekosten" hint="Per maand" name="manualRoundPrice" v-model.trim="pendingLoggerType.manualRoundPrice"
                            v-validate="'min_value:0'" data-vv-as="Handmeetrondekosten" :error="error('manualRoundPrice')"></cms-form-input>

        </cms-form-panel>
    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag';

    import pick from 'lodash/pick'
    import clone from 'lodash/clone'

    import LoggerTypeMutations from 'app/mutations/LoggerTypeMutations'
    import LoggerTypeQueries from 'app/queries/LoggerTypeQueries'

    @Component({

        name: 'logger-type-form',
        apollo: {

            loggerType: LoggerTypeQueries.find({

                skip(){
                    return !this.$route.params.id;
                },

                result(result){

                    if(result && result.data) {
                        this.pendingLoggerType = pick(result.data.viewer.findLoggerType, ['title', 'loggerPrice', 'usagePrice', 'backofficePrice', 'failurePrice', 'manualRoundPrice']);
                    }
                },

                variables(){

                    return {
                        typeId: this.itemId
                    }
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                loggerType: null,
                pendingLoggerType: {
                    title: null,
                    loggerPrice: null,
                    usagePrice: null,
                    backofficePrice: null,
                    failurePrice: null,
                    manualRoundPrice: null
                },

                submitting: false,
                submitted: false,

                loading: 0
            }
        }

        breadcrumb(){

            return [{
                title: 'Overzicht logger-types',
                route: {
                    name: 'logger-types'
                }
            }, this.pageTitle]
        }

        created(){

            this.logger = this.$logger.child('LoggerTypeForm');
        }

        get pageTitle(){

            var pageTitle = null;

            if(this.itemId){
                pageTitle = this.loggerType ? this.loggerType.title : '';
            }
            else {
                pageTitle = 'Logger-type toevoegen';
            }

            return pageTitle;
        }

        get itemId(){

            return this.$route.params.id;
        }

        onQueryError(){

            this.$toast.error('Het logger-type kon niet worden opgehaald');
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                    return;
                }

                this.submitting = true;
                var loggerTypeData = {
                    ...clone(this.pendingLoggerType),
                    loggerPrice: this.pendingLoggerType.loggerPrice ? parseFloat(this.pendingLoggerType.loggerPrice) : null,
                    usagePrice: this.pendingLoggerType.usagePrice ? parseFloat(this.pendingLoggerType.usagePrice) : null,
                    backofficePrice: this.pendingLoggerType.backofficePrice ? parseFloat(this.pendingLoggerType.backofficePrice) : null,
                    failurePrice: this.pendingLoggerType.failurePrice ? parseFloat(this.pendingLoggerType.failurePrice) : null,
                    manualRoundPrice: this.pendingLoggerType.manualRoundPrice ? parseFloat(this.pendingLoggerType.manualRoundPrice) : null
                }

                if(this.loggerType) {

                    loggerTypeData.id = this.loggerType.id;

                    LoggerTypeMutations.update(loggerTypeData).then(() => {

                        this.logger.info('Logger type updated');
                        this.$toast.success('Het logger-type is opgeslagen');

                        this.submitting = false;

                        this.$router.push({
                            name: 'logger-types'
                        });

                    }).catch(e => this.handleSubmitError(e));
                }
                else {

                    LoggerTypeMutations.create(loggerTypeData).then(() => {

                        this.logger.info('Logger type created');
                        this.$toast.success('Het logger-type is aangemaakt');

                        this.submitting = false;

                        this.$router.push({
                            name: 'logger-types'
                        });

                    }).catch(e => this.handleSubmitError(e));
                }
            });
        }

        handleSubmitError(e){

            this.logger.error('Error saving logger-type', e);
            this.$toast.error('Het logger-type kon niet worden opgeslagen');

            this.submitting = false;
        }
    }

</script>
